import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'react-toastify/dist/ReactToastify.css';
import App from './Components/App/App';
import reportWebVitals from './reportWebVitals';
import AuthContextProvider from './Context/AuthContext.jsx';
import 'react-icons/index.js';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import 'swiper/css';
import './index.css';
import WishListContextProvider from './Context/WishListContext.jsx';
import CartContextProvider from './Context/CartContext.jsx';
import CheckOutContextProvider from './Context/CheckOutContext.jsx';
import ProductsContextProvider from './Context/ProductsContext.jsx';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <AuthContextProvider>
    <ProductsContextProvider>
      <WishListContextProvider>
        <CartContextProvider>
          <CheckOutContextProvider>
            <App />
          </CheckOutContextProvider>
        </CartContextProvider>
      </WishListContextProvider>
    </ProductsContextProvider>
  </AuthContextProvider>
  // </React.StrictMode>
);
reportWebVitals();
